zc.collections.Invites = Backbone.Collection.extend({
    model: zc.models.Invite
});
